import quickfireModel from "quickfire/model/quickfire-model";
import Components from "slotworks/components/components";
import AutoplayModel from "slotworks/model/autoplay/autoplay-model";
import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import SettingsModel from "slotworks/model/settings/settings-model";
import { Services } from "slotworks/services/services";
import StateMachine from "slotworks/state-machine/state-machine";
import DeviceInfo from "slotworks/utils/device-info";

class VAnalytics {
    private quickStopped: boolean = false;

    public init() {
        V.API.SlotAnalytics.setCurrencyMode("credits");
        this.sendSettings();

        StateMachine.onStateEnter.add((stateName: string) => {
            if (stateName.indexOf("request-spin") > -1) {
                this.spin();
            }
        });

        StateMachine.onStateExit.add((stateName: string) => {
            if (stateName === "spin") {
                this.stop();
            }
        });

        Components.matrix.skipSignal.add(() => this.quickStopped = true);
    }

    public spin() {
        this.sendSettings();

        V.API.SlotAnalytics.startSpinEvent();
    }

    public stop() {
        V.API.GameAnalytics.setContextData(V.API.GameAnalytics.ContextItems.KEY_TRANSACTION_ID, quickfireModel.transactionNumber);
        V.API.SlotAnalytics.sendSpinEvent(this.getSpinMethod(), this.quickStopped);

        this.quickStopped = false;
    }

    private sendSettings() {
        V.API.SlotAnalytics.setQuickSpins(SettingsModel.getTurboSpin());

        const masterMute = Services.sound.getMuted();
        const sfxMute = Services.sound.getSoundFxMuted();
        const musicMute = Services.sound.getMusicMuted();

        V.API.SlotAnalytics.setGameSounds(masterMute ? false : !sfxMute);
        V.API.SlotAnalytics.setBackgroundSounds(masterMute ? false : !musicMute);
        V.API.SlotAnalytics.setWinSounds(masterMute ? false : !sfxMute);
    }

    private getSpinMethod() {
        let spinMethod = "Tap";

        if (DeviceInfo.isDesktop) {
            spinMethod = "Click";
        }

        if (AutoplayModel.isAutoPlaying()) {
            spinMethod = "Autoplay";
        }

        if (GameState.getCurrentGame()) {
            const record = GameState.getCurrentGame().getCurrentRecord();
            if (record && (record instanceof FreespinRecord || record.getFreespinsWon() > 0)) {
                spinMethod = "FreeSpin";
            }
        }

        if (quickfireModel.playingFreeGames) {
            spinMethod = "FreeGameSpin";
        }

        return spinMethod;
    }

}

export default new VAnalytics();
